


























































































import { Vue } from "division-marker";
import { Component, Prop, Watch } from "division-marker";
import { DmShareds } from "saiten-base";
import RejectDialog from "./RejectDialog.vue";
import UploadDialog from "./UploadDialog.vue"
import WtHttp from '@/components/WtHttp';
import addDays from "date-fns/add_days";

class Condition {
  student_id: string | null = null;
  created_at_from: string | null = DmShareds.DateUtil.to_yyyymmdd_hyphen(
      addDays(new Date(), -6)
  );
  created_at_to: string | null = DmShareds.DateUtil.to_yyyymmdd_hyphen(new Date());
  saiten_state: string = "0";

  sort_column: string = "created_at";
  sort_type: string = "desc";
}

@Component({ components: { RejectDialog, UploadDialog }, mixins: [] })
export default class QuestionAnswers extends Vue {
  search_results: any[] | null = null;
  condition = new Condition();
  searched_condition = new Condition();
  saiten_states = [
      {id: -1, name: "再送信"},
      {id: 1, name: "回答中"},
      {id: 10, name: "完了"}
  ];
  get reject_dialog(): RejectDialog {
    return this.$refs.reject_dialog as RejectDialog;
  }
  get upload_dialog(): UploadDialog {
    return this.$refs.upload_dialog as UploadDialog;
  }

  mounted() {
    this.search();
  }

  // 検索処理
  async search() {
    this.searched_condition = Object.assign(new Condition(), this.condition);
    this.load();
  }
  async sort(sort_column: string){
    const old_sort_column = this.condition.sort_column;
    const old_sort_type = this.condition.sort_type;
    this.condition.sort_column = sort_column;
    this.searched_condition.sort_column = sort_column;
    const sort_type = (sort_column == old_sort_column && old_sort_type == 'asc') ? 'desc' : 'asc';
    this.condition.sort_type = sort_type;
    this.searched_condition.sort_type = sort_type;
    this.load();
  }
  async load(){
    try {
      this.search_results = null;
      const res = await WtHttp.post("./api/dm/question_answers", this.searched_condition);
      const data = res.data;
      console.log(data);
      const search_results = data.search_results;
      this.search_results = search_results;
    } catch (err) {
      alert(err);
    }
  }

  show_ng_dialog(data: any) {
    this.reject_dialog.show(data);
  }

  show_upload_dialog(data: any) {
    this.upload_dialog.show(data);
  }

  to_yyyymmdd_hhmmss_slash(value: Date) {
    return DmShareds.DateUtil.to_yyyymmdd_hhmmss_slash(value)
  }
}
